import React, { Component } from "react";
import Card from "@material-ui/core/Card";
import { withStyles } from "@material-ui/core/styles";
import CardActionArea from "@material-ui/core/CardActionArea";
import CardMedia from "@material-ui/core/CardMedia";
import CardContent from "@material-ui/core/CardContent";
import Typography from "@material-ui/core/Typography";
import { withTranslation, Trans } from "react-i18next";

const styles = (theme) => ({
  cardBody: {
    textAlign: "center",
  },
  img: {
    margin: "auto",
    height: 80,
    width: "auto",
    paddingTop: 20,
  },
});

export class SourceTypeCard extends Component {
  render() {
    const { classes } = this.props;
    return (
      <Card>
        <CardActionArea onClick={this.props.onSelect} id={this.props.id}>
          <CardMedia
            src={this.props.isImage ? this.props.icon : ""}
            title={this.props.t(this.props.titleTranslated)}
            className={classes.img}
            component={this.props.isImage ? "img" : this.props.icon}
          />
          <CardContent className={classes.cardBody}>
            <Typography variant="h5" component="h2">
              <Trans i18nKey={this.props.titleTranslated}>
                {this.props.titleTranslated}
              </Trans>
            </Typography>
            <Typography variant="body2" color="textSecondary" component="p">
              <Trans i18nKey={this.props.description}>
                {this.props.description}
              </Trans>
            </Typography>
          </CardContent>
        </CardActionArea>
      </Card>
    );
  }
}

export default withTranslation()(withStyles(styles)(SourceTypeCard));
